import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Types
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';
import type { LabelProps } from '@Shelly/shelly-design-system/index';

export const buildRollerLabels = (
	method: string,
	job: ActionJob,
	labelList: LabelProps[],
): LabelProps[] => {
	const $format = get(format);
	const state = method.split('.')[1];
	if (/open|close|gotoposition|stop/.test(state)) {
		if (state == 'gotoposition') {
			if (typeof job.params.pos !== 'undefined') {
				labelList.push({
					value: `${job.params.pos}%`,
					icon: `far fa-blinds-raised`,
				});
			}
		} else {
			labelList.push({
				value: $format(`schedule_action_${state}`, {
					default: state,
				}),
				icon: `far fa-blinds${/clos/.test(state) ? '' : '-raised'}`,
			});
		}
		//addition of icons for new props slat_pos and slat_rel to cover.gotoposition
		if (typeof job.params.slat_pos !== 'undefined') {
			labelList.push({
				value: job.params.slat_pos + '%',
				icon: 'fas fa-blinds-open',
			});
		}
		if (typeof job.params.slat_rel !== 'undefined') {
			labelList.push({
				value: job.params.slat_rel + '%',
				icon: 'fas fa-arrows-rotate', //temporary choice
			});
		}
	}
	return labelList;
};

export const stringifyRollerAction = (action: ActionJob): string => {
	const $format = get(format);
	const params = action.params;
	let actionStringify = '';
	if (Number.isFinite(params.pos)) {
		actionStringify += ` ${$format('target_position', {
			default: 'Target position',
		})}: ${params.pos}% , `;
	}
	if (Number.isFinite(params.slat_pos)) {
		//gen 2++ tilt position
		actionStringify += ` ${$format('slat_position', {
			default: `Tilt position: ${params.slat_pos}%`,
			values: { pos: params.slat_pos },
		})}, `;
	}
	if (Number.isFinite(params.slat_rel)) {
		//gen 2++ relative tilt position
		actionStringify += ` ${$format('relative_tilt_position', {
			default: `Relative ilt position: ${params.slat_rel}%`,
			values: { pos: params.slat_rel },
		})}, `;
	}
	return actionStringify;
};
